import { render, staticRenderFns } from "./ServicePlaceRegister.vue?vue&type=template&id=7f45b37c&scoped=true&"
import script from "./ServicePlaceRegister.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f45b37c",
  null
  
)

export default component.exports